import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const IconGeneral = (props: IconProps) => {
  return (
    <SvgIcon {...props} fill="transparent" color="inherit" viewBox="0 0 28 28">
      <path
        d="M14 24C19.5229 24 24 19.5228 24 14C24 8.47715 19.5229 4 14 4C8.47718 4 4.00003 8.47715 4.00003 14C4.00003 19.5228 8.47718 24 14 24Z"
        stroke="#2E434D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M4.00003 14H24"
        stroke="#2E434D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M14 4C16.5013 6.73835 17.9228 10.292 18 14C17.9228 17.708 16.5013 21.2616 14 24C11.4988 21.2616 10.0773 17.708 10 14C10.0773 10.292 11.4988 6.73835 14 4V4Z"
        stroke="#2E434D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </SvgIcon>
  );
};

export default IconGeneral;
